/* eslint-disable jsx-a11y/img-redundant-alt */
import { Href } from "../../../Constant";
import { Gallery, Item } from "react-photoswipe-gallery";
import { GALLARY_IMAGE } from "../../../Data/Gallery";
import { dynamicImage } from "../../../Service/DynamicImage";
import { Link } from "react-router-dom";

export const MyGallery = () => {
  return (
    <Gallery>
      {GALLARY_IMAGE.map((item, index) => (
        <figure className="col-xl-3 col-md-4 col-xs-6 m-0" key={index}>
          <Item original={dynamicImage(item)} width="1500" height="850">
            {({ ref, open }) => (
              <Link to={Href} onClick={open}>
                <img height="500" width="500" className="img-thumbnail mb-4" ref={ref} src={dynamicImage(item)} alt="image" />
              </Link>
            )}
          </Item>
        </figure>
      ))}
    </Gallery>
  );
};
